import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
  useTheme,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import fallbackLogo from 'src/assets/images/auth/login-1.png';

const ClinicInfo = ({ data }) => {
  const theme = useTheme();

  if (!data) return null;

  const {
    clinicLogo,
    title,
    tagLine,
    address,
    area,
    city,
    state,
    country,
    description,
    contactNo,
  } = data;

  const handleCallClick = () => {
    if (contactNo) {
      window.location.href = `tel:${contactNo}`;
    }
  };

  const handleBookAppointmentClick = () => {
    window.open(`/book-appointment/${title.replace(/\s+/g, '-').toLowerCase()}`, '_blank');
  };

  return (
    <Card
      elevation={3}
      sx={{
        mb: 4,
        boxShadow: theme.shadows[1],
        backgroundColor: theme.palette.gery.white,
      }}
    >
      <Grid container spacing={3} p={3} alignItems="center">
        {/* Clinic Logo */}
        <Grid item xs={12} md="auto">
          <Box
            component="img"
            src={
              clinicLogo
                ? `${process.env.REACT_APP_BASE_API_URL}${clinicLogo}`
                : fallbackLogo
            }
            alt="Clinic Logo"
            sx={{
              width: 140,
              height: 140,
              objectFit: 'contain',
              borderRadius: 2,
              border: `1px solid ${theme.palette.gery.lightGray}`,
              backgroundColor: theme.palette.gery.extraLightGray,
              p: 1,
            }}
          />
        </Grid>

        {/* Clinic Info */}
        <Grid item xs>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            height="100%"
          >
            <Box>
              <Typography variant="h1" gutterBottom>
                {title}
              </Typography>
              {tagLine && (
                <Typography variant="h5" color="text.secondary" gutterBottom>
                  {tagLine}
                </Typography>
              )}
              {address && (
                <Typography variant="body1" color="text.secondary">
                  {address}, {area}, {city}, {state}, {country}
                </Typography>
              )}
            </Box>

            <Box mt={2} display="flex" gap={2} flexWrap="wrap">
              <Button
                variant="contained"
                sx={{ backgroundColor: theme.palette.action.green }}
                startIcon={<EventAvailableIcon />}
                onClick={handleBookAppointmentClick}
              >
                Book Appointment
              </Button>
              <Button
                variant="outlined"
                sx={{
                  borderColor: theme.palette.action.green,
                  color: theme.palette.action.green,
                  '&:hover': {
                    backgroundColor: theme.palette.actionLight.green,
                  },
                }}
                startIcon={<PhoneIcon />}
                onClick={handleCallClick}
              >
                Call Clinic
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* About Clinic */}
      {description && (
        <>
          <Divider />
          <CardContent>
            <Typography variant="h3" gutterBottom>
              About Clinic
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </CardContent>
        </>
      )}
    </Card>
  );
};

export default ClinicInfo;
